// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"BuildingList_searchInput__2LPB8"};